<template>
  <div class="bill-checkout-form">
    <b-form-group>
      <label class="required-control">
        Cửa hàng:<b class="text-danger">*</b>
      </label>
      <treeselect
        ref="store-option"
        :options="optionStores"
        :multiple="false"
        placeholder="Nhập cửa hàng"
        retryText="Thử lại..."
        retryTitle="Nhấp thử lại"
        loadingText="Đang tải..."
        noResultsText="Không có kết quả"
        :match-keys="['label', 'shortName']"
        v-model="billModel.storeId"
        @select="onSelectStore"
        :disabled="billModel.id"
      />
      <b-form-invalid-feedback :state="validateState('searchStore')">
        Vui lòng nhập cửa hàng
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group :disabled="true">
      <label class="lable-form">Chiết khấu:</label>
      <b-row>
        <b-col class="pr-0" cols="3">
          <b-form-select
            class="select-style"
            v-model="billModel.discountType"
            :options="listAmountType"
            size="sm"
            value-field="id"
            text-field="name"
          >
          </b-form-select>
        </b-col>
        <b-col class="pl-0" cols="9">
          <BInputNumber
            v-model="billModel.discountAmount"
            placeholder="Chiết khấu"
            :inputClass="'input-style text-right'"
          />
        </b-col>
      </b-row>
    </b-form-group>
    <div class="row-center-vertical">
      <b-col md="6" class="no-side">
        <p class="textPayment">Thanh toán</p>
      </b-col>
      <b-col md="6" class="no-side">
        <p class="textPoint text-right" v-if="billModel.isCountPoint">
          {{ 0 }} điểm
        </p>
      </b-col>
    </div>
    <b-row class="mb-1">
      <b-col md="6">
        <span class="textTitlePayment">Tổng tiền:</span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(totalBillAmount) }}
        </span>
      </b-col>
    </b-row>
    <b-row v-if="totalPaid > 0" class="mb-1">
      <b-col md="6">
        <span class="textTitlePayment"> Khách đã thanh toán: </span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(totalCustomerPaid) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col md="6">
        <span class="textTitlePayment"> Cần hoàn trả: </span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(finalAmount) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col md="6">
        <span class="textTitlePayment"> Cần trả khách: </span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(needPaid) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col md="6">
        <span class="textTitlePayment"> Đã trả khách: </span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(totalPaid) }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mb-1" v-if="totalRemain">
      <b-col md="6">
        <span class="textTitlePayment"> Còn thiếu: </span>
      </b-col>
      <b-col md="6" class="text-right">
        <span class="textPayment">
          {{ convertPrice(totalRemain) }}
        </span>
      </b-col>
    </b-row>
    <BillRefundPayment
      ref="bill-payment"
      :finalAmount="finalAmount"
      :billData="billModel"
      :onSubmiting="onPaymentSubmiting"
      :disabled="false"
      v-on:onUpdate="onUpdatePayment"
      v-on:receive-payment="onUpdatePayment"
      v-on:receive-payment-mul="onUpdatePaymentV2"
    />
  </div>
</template>

<script>
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';
import calculateMixin from '@/view/mixins/calculate.mixins.js';
import Treeselect from '@riophae/vue-treeselect';
import _sumBy from 'lodash/sumBy';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';
import { convertPrice, cloneDeep } from '@/utils/common';
import { PAYMENT_TYPE } from '@/utils/enum';
import BillRefundPayment from './BillRefundPayment.vue';

export default {
  mixins: [apiCommonMixin, calculateMixin],
  props: {
    billModel: Object,
    saleBillModel: Object,
  },
  data() {
    return {
      optionStores: null,
      listAmountType: [
        {
          id: 1,
          name: '$',
        },
        {
          id: 2,
          name: '%',
        },
      ],
      onPaymentSubmiting: false,
    };
  },
  components: {
    Treeselect,
    BInputNumber,
    BillRefundPayment,
  },
  computed: {
    totalBillAmount() {
      const billItemAmount = this.calculateAmountBillItems(
        this.billModel.billItems,
      );
      const discountAmount = this.calculateDiscountAmount(
        this.billModel.discountAmount,
        this.billModel.discountType,
        billItemAmount,
      );
      return billItemAmount - discountAmount;
    },
    totalCustomerPaid() {
      return (
        this.saleBillModel.cashAmount +
        this.saleBillModel.transferAmount +
        this.saleBillModel.creditAmount +
        this.saleBillModel.installedMoneyAmount +
        this.saleBillModel.moneyPaid +
        this.saleBillModel.moneyTransfered +
        this.saleBillModel.moneyCredit +
        this.saleBillModel.moneyInstallment
      );
    },
    finalAmount() {
      if (!this.totalBillAmount) {
        return 0;
      }
      return this.totalCustomerPaid > this.totalBillAmount || this.billModel.id
        ? this.totalBillAmount
        : this.totalCustomerPaid;
    },
    needPaid() {
      return this.finalAmount - this.billModel.paymentInfo.refundFee;
    },
    totalPaid() {
      const payments = [...this.billModel.cash, ...this.billModel.transfer];
      return _sumBy(payments, 'paymentAmount');
    },
    totalRemain() {
      return this.needPaid - this.totalPaid;
    },
  },
  watch: {
    'billModel.storeId': {
      handler(newVal) {
        if (this.billModel.id) {
          this.optionStores = [
            {
              id: newVal,
              label: this.billModel.storeName || null,
            },
          ];
        }
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.billModel.storeId) {
      this.optionStores = [
        {
          id: this.billModel.storeId,
          label: this.billModel.storeName || null,
        },
      ];
    } else {
      const { stores, currentStoreId, currentStoreName } =
        await this.fetchStoreByUser();

      this.optionStores = this.mapDataTreeSelect(stores, [
        'id',
        'name',
        'shortName',
      ]);

      if (currentStoreId) {
        this.billModel.storeId = currentStoreId;
        this.billModel.storeName = currentStoreName;
      }
    }
  },
  methods: {
    convertPrice,
    onSelectStore(node) {
      if (node.id && node.id !== this.billModel.storeId) {
        this.billModel.storeId = node.id;
        this.billModel.storeName = node.label;
      } else {
        this.billModel.storeId = null;
        this.billModel.storeName = null;
      }
    },
    validateState(name) {
      if (!name) return null;
    },
    mapDataTreeSelect(items = [], keys = []) {
      return items.map((element) => {
        return {
          id: element[keys[0]],
          label: element[keys[1]],
          shortName: element[keys[2]],
        };
      });
    },
    onUpdatePayment(paymentInfo) {
      this.billModel.paymentInfo = cloneDeep(paymentInfo);
    },
    onUpdatePaymentV2(items = [], type) {
      const payments = items.reduce((result, current) => {
        result.push({
          ...current,
          paymentAmount: current.paymentAmount,
        });
        return result;
      }, []);
      switch (type) {
        case PAYMENT_TYPE.INSTALLMENT: {
          this.billModel.installments = payments;
          break;
        }
        case PAYMENT_TYPE.CREDIT: {
          this.billModel.credits = payments;
          break;
        }
        case PAYMENT_TYPE.TRANSFER: {
          this.billModel.transfer = payments;
          break;
        }
        case PAYMENT_TYPE.CASH: {
          this.billModel.cash = payments;
          break;
        }
        case PAYMENT_TYPE.REFUND: {
          this.billModel.refunds = payments;
          break;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.bill-checkout-form {
  .vue-treeselect__input-container {
    padding-top: 0px;
  }

  .vue-treeselect__control {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    height: 2.5rem;
  }

  .vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 2px;
  }

  .header-color {
    color: rgb(24, 28, 50);
  }
  .text-note {
    font-size: 12px;
    font-style: italic;
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -webkit-pre-wrap; /* Chrome & Safari */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* CSS3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: break-word;
    white-space: normal;
  }
  .row-center-vertical {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .textPayment {
    font-size: 16px;
    font-weight: 500;
    color: brown;
  }
}
</style>
